<template>
  <div>
    <div class="button-togle">
      <div class="link-ico" @click.stop="shareDrawer = !shareDrawer">
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" color="#1a73e8" size="25px"
              >mdi-link-variant</v-icon
            >
          </template>
          <span class="v-tooltip-content v-tooltip-left">Shareable Links</span>
        </v-tooltip>
      </div>
    </div>
    <v-navigation-drawer
      v-model="shareDrawer"
      fixed
      temporary
      right
      width="390"
    >
      <div class="wrapper-right">
        <div class="sharable-links-wrap">
          <div class="d-flex justify-content-between align-items-start">
            <h3>Shareable Links</h3>
            <div
              class="cursor-pointer"
              @click.stop="shareDrawer = !shareDrawer"
            >
              <v-icon color="#1c1d26" size="25px">mdi-close</v-icon>
            </div>
          </div>
          <p>
            Link for attendees and speakers to access your event, or stream over
            RTMP
          </p>
        </div>

        <div>
          <div class="event-links-wrapper position-relative">
            <!-- <h3>Shareable Links</h3> -->
            <div class="tabs-wrap mt-8">
              <v-tabs background-color="transparent" color="#1a73e8" grow>
                <v-tab href="#tab1"> Registration </v-tab>
                <v-tab href="#tab2"> e2m Studio </v-tab>
                <v-tab href="#tab3"> RTMP </v-tab>
                <v-tab-item value="tab1">
                  <v-card color="basil" flat>
                    <v-card-text>
                      <div class="p-4 common-fields-wrap">
                        <p>
                          Use this link to invite people to join your
                          registration page:
                        </p>
                        <div
                          class="
                            d-flex
                            justify-content-between
                            align-items-center
                          "
                        >
                          <label>Registration link</label>
                          <span id="reglinkCopied" style="display: none"
                            >copied!</span
                          >
                        </div>
                        <div class="link-feild-wrap">
                          <input
                            type="text"
                            id="reglink"
                            :value="getPublishLink"
                          />
                          <v-btn @click="copyEventLink"
                            ><v-icon>mdi-content-copy</v-icon></v-btn
                          >
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-tab-item>

                <v-tab-item value="tab2">
                  <v-card color="basil" flat>
                    <v-card-text>
                      <div class="p-4 common-fields-wrap">
                        <p>
                          Use this link to invite speakers into the backstage:
                        </p>

                        <div class="link-feild-wrap mt-8">
                          <div class="down-arrow-ico">
                            <v-icon color="#333" size="25px"
                              >mdi-chevron-down</v-icon
                            >
                          </div>
                          <v-menu offset-y max-height="300">
                            <template v-slot:activator="{ on, attrs }">
                              <div
                                class="link-drop"
                                dark
                                v-bind="attrs"
                                v-on="on"
                              >
                                {{ selectedSpeaker.Name }}
                              </div>
                            </template>
                            <v-list>
                              <v-list-item
                                v-for="speaker in speakerList"
                                :key="speaker"
                                @click="onSpeakerSelected(speaker)"
                              >
                                <v-list-item-title
                                  class="position-relative sp-name-btn"
                                >
                                  <h4>{{ speaker.Name }}</h4>
                                  <p>{{ speaker.Designation }}</p>
                                  <p>{{ speaker.Company }}</p>
                                </v-list-item-title>
                              </v-list-item>
                            </v-list>
                          </v-menu>
                        </div>
                        <div
                          class="
                            d-flex
                            justify-content-between
                            align-items-center
                          "
                        >
                          <label>e2m studio link</label>
                          <span id="speakerlinkCopied" style="display: none"
                            >copied!</span
                          >
                        </div>
                        <div class="link-feild-wrap">
                          <input
                            type="text"
                            id="speakerlink"
                            :value="speakerJoinURL"
                          />
                          <v-btn @click="copySpeakerLink"
                            ><v-icon>mdi-content-copy</v-icon></v-btn
                          >
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-tab-item>

                <v-tab-item value="tab3">
                  <v-card color="basil" flat>
                    <v-card-text>
                      <div class="p-4 common-fields-wrap">
                        <p class="mb-2">
                          If you are using RTMP, use this key and link to stream
                          your broadcast:
                        </p>
                        <div>
                          <div class="position-relative cursor-pointer">
                            <div class="down-arrow-ico">
                              <v-icon color="#333" size="25px"
                                >mdi-chevron-down</v-icon
                              >
                            </div>
                            <v-menu offset-y max-height="300">
                              <template v-slot:activator="{ on, attrs }">
                                <div
                                  class="link-drop"
                                  dark
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  <p class="m-0">{{ selectedSession.Name }}</p>
                                </div>
                              </template>
                              <v-list>
                                <v-list-item
                                  v-for="session in sessionList"
                                  :key="session"
                                  @click="onSessionSelected(session)"
                                >
                                  <v-list-item-title
                                    class="position-relative sp-name-btn"
                                  >
                                    <h4>{{ session.Name }}</h4>
                                    <p>{{ session.TrackName }}</p>
                                    <p>{{ session.SessionTime }}</p>
                                  </v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </div>
                        </div>
                        <div
                          class="
                            d-flex
                            justify-content-between
                            align-items-center
                          "
                        >
                          <label>Stream key</label>
                          <span id="streamKeyCopied" style="display: none"
                            >copied!</span
                          >
                        </div>
                        <div class="link-feild-wrap mb-3">
                          <input
                            type="text"
                            id="streamKey"
                            :value="streamKey"
                          />
                          <v-btn @click="copyStreamKey"
                            ><v-icon>mdi-content-copy</v-icon></v-btn
                          >
                        </div>
                        <div
                          class="
                            d-flex
                            justify-content-between
                            align-items-center
                          "
                        >
                          <label>RTMP URL</label>
                          <span id="RTMPURLCopied" style="display: none"
                            >copied!</span
                          >
                        </div>
                        <div class="link-feild-wrap">
                          <input type="text" id="RTMPURL" :value="RTMPURL" />
                          <v-btn @click="copyRTMPURL"
                            ><v-icon>mdi-content-copy</v-icon></v-btn
                          >
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
              </v-tabs>
            </div>
          </div>
        </div>
      </div>

      <div class="links-tab-wrap"></div>
    </v-navigation-drawer>
  </div>
</template>
<script>
import APIs from "@/components/APIInit";
import axios from "axios";
import db from "../components/firebaseInit";
import common from "@/common";
import store from "@/store";

var vm;
export default {
  // props: {
  //   eventFullName: {
  //     type: String,
  //     default: "",
  //   },
  //   eventTime: {
  //     type: String,
  //     default: "",
  //   },
  // },
  data() {
    return {
      shareDrawer: false,
      clientId: "",
      eventId: "",
      eventCollectionName: "",
      speakerJoinURL: "",
      selectedSpeaker: {
        SpeakerId: "",
        Name: "Speaker's Name",
        Company: "",
        Designation: "",
        Email: "",
      },
      speakerList: [],
      selectedSession: {
        SessionId: "",
        Name: "Sesssion Name",
        TrackName: "",
        SessionTime: "",
      },
      sessionList: [],
      streamKey: "",
      RTMPURL: "",
    };
  },
  computed: {
    getPublishLink() {
      var customDomain = store.state.customDomain;
      var eventId = this.getEventId();
      return "https://" + customDomain + "/eventv3/" + eventId;
    },
  },
  created() {},
  mounted() {
    vm = this;
    vm.clientId = vm.getClientId();
    vm.eventId = vm.getEventId();
    vm.eventCollectionName = vm.getEventCollectionName();
    vm.getSpeakerList();
    vm.getSessionList();
  },
  methods: {
    getSpeakerList() {
      vm.speakerList = [];
      db.collection(vm.eventCollectionName)
        .doc("SpeakerList")
        .collection("Speakers")
        .where("IsPublished", "==", true)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            debugger;
            let data = doc.data();
            vm.speakerList.push({
              SpeakerId: data.SpeakerId,
              Name: data.Name,
              Company: data.Company,
              Designation: data.Designation,
              Email: data.Email,
            });
          });
          vm.speakerList.sort(function (a, b) {
            if (a.Name < b.Name) {
              return -1;
            }
            if (a.Name > b.Name) {
              return 1;
            }
            return 0;
          });
          //alert(vm.speakerList.length)
          if (vm.speakerList.length > 0) {
            //alert(vm.speakerList[0].Name)

            //vm.selectedSpeaker = vm.speakerList[0];
            vm.onSpeakerSelected(vm.speakerList[0]);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    onSpeakerSelected(speaker) {
      console.log(speaker);
      debugger;
      vm.speakerJoinURL = "";
      vm.selectedSpeaker = speaker;
      if (speaker.SpeakerId) {
        let headers = {
          "content-type": "application/json",
          Authorization: "Bearer " + vm.getSessionToken(),
        };
        let requestData = {
          key: {
            instanceId: "OA_UAT",
            clientId: vm.clientId,
            eventId: vm.eventId,
          },
          data: {
            userId: speaker.SpeakerId,
          },
        };
        axios
          .post(APIs.GetJoinURL, requestData, {
            headers: headers,
          })
          .then((response) => {
            //vm.ManageMenuUpdating = false;
            if (response && response.data && response.data.status == 0) {
              vm.speakerJoinURL = response.data.joinURL;
            } else {
              //vm.showSnackbar("Menu updated failed!", "error", "top");
            }
          })
          .catch((error) => {
            //vm.ManageMenuUpdating = false;
            debugger;
            //alert("SaveManageMenu Failure");
            console.log("onSpeakerSelected: " + error);
            //vm.showSnackbar("Menu updated failed!", "error", "top");
          });
      }
    },
    getSessionList() {
      vm.sessionList = [];
      db.collection(vm.eventCollectionName)
        .doc("SessionList")
        .collection("Sessions")
        .where("IsPublished", "==", true)
        .orderBy("StartDate", "asc")
        .orderBy("EndDate", "asc")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            let data = doc.data();
            if (data.StreamingClient == "Zoom") {
              let sessionTime = common.getFormattedDateTime(
                data.StartDate.seconds
              );
              let sessionEndTime = common.getFormattedDateTime(
                data.EndDate.seconds
              );
              sessionTime += " - " + sessionEndTime;
              if (
                sessionTime.substring(0, 8) == sessionEndTime.substring(0, 8)
              ) {
                sessionTime = sessionTime.replaceAll(
                  sessionEndTime.substring(0, 8),
                  ""
                );
              }
              vm.sessionList.push({
                SessionId: data.SessionId,
                Name: data.Name,
                TrackName: data.Track.TrackName,
                SessionTime: sessionTime,
                ZoomRTMPMUX_detail: data.ZoomRTMPMUX_detail,
              });
            }
          });
          if (vm.sessionList.length > 0) {
            vm.selectedSession = vm.sessionList[0];
            vm.onSessionSelected(vm.selectedSession);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    onSessionSelected(session) {
      (vm.streamKey = ""), (vm.RTMPURL = "");
      vm.selectedSession = session;
      if (session.SessionId && session.ZoomRTMPMUX_detail) {
        (vm.streamKey =
          session.ZoomRTMPMUX_detail.data.rtmpPushEndpoint.streamKey),
          (vm.RTMPURL = session.ZoomRTMPMUX_detail.data.rtmpPushEndpoint.url);
      }
    },
    copyEventLink() {
      var ct = document.getElementById("reglink");
      ct.select();
      ct.setSelectionRange(0, 99999);
      document.getElementById("reglinkCopied").style.display = "block";
      document.execCommand("copy");
      setTimeout(function () {
        document.getElementById("reglinkCopied").style.display = "none";
      }, 1000);
    },
    copySpeakerLink() {
      var ct = document.getElementById("speakerlink");
      ct.select();
      ct.setSelectionRange(0, 99999);
      document.getElementById("speakerlinkCopied").style.display = "block";
      document.execCommand("copy");
      setTimeout(function () {
        document.getElementById("speakerlinkCopied").style.display = "none";
      }, 1000);
    },
    copyStreamKey() {
      var ct = document.getElementById("streamKey");
      ct.select();
      ct.setSelectionRange(0, 99999);
      document.getElementById("streamKeyCopied").style.display = "block";
      document.execCommand("copy");
      setTimeout(function () {
        document.getElementById("streamKeyCopied").style.display = "none";
      }, 1000);
    },
    copyRTMPURL() {
      var ct = document.getElementById("RTMPURL");
      ct.select();
      ct.setSelectionRange(0, 99999);
      document.getElementById("RTMPURLCopied").style.display = "block";
      document.execCommand("copy");
      setTimeout(function () {
        document.getElementById("RTMPURLCopied").style.display = "none";
      }, 1000);
    },
  },
};
</script>